export function storeName(
  shopName: string,
  retailerTitle?: string | null
): string {
  return retailerTitle || shopName
}

export function generateStoreFrontUrl(
  retailerId?: string | null,
  retailerSlug?: string | null
): string | undefined {
  return retailerId && retailerSlug
    ? `/store/${retailerId}/${retailerSlug}`
    : undefined
}
